import React from 'react';
import styled from 'styled-components';
import PercentageField, { PercentageFieldProps } from './PercentageField';
import { faTrashXmark } from '@fortawesome/pro-light-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { COLORS } from 'shared/design-system/settings/variables/Colors';

interface PercentageFieldWithLabelProps extends PercentageFieldProps {
  label: string;
  className?: string;
  justifyContent?: 'center' | 'space-between';
  onRemove?: () => unknown;
}

const StyledDiv = styled.div<{
  disabled: PercentageFieldWithLabelProps['disabled']
  justifyContent?: PercentageFieldWithLabelProps['justifyContent'];
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${({ disabled }: { disabled?: boolean }) =>
    disabled && COLORS.disabledText};
  .delete-icon {
    cursor: pointer;
    margin-left: 10px;
  }
  .right-column {
    display: flex;
    align-items: center;
  }
`;

const PercentageFieldWithLabel: React.FC<PercentageFieldWithLabelProps> = ({
  label,
  justifyContent,
  className,
  onRemove,
  ...props
}) => {
  return (
    <StyledDiv
      justifyContent={justifyContent}
      disabled={props.disabled}
      className={className}
    >
      {label}
      <div className='right-column'>
        <PercentageField {...props} />
        {onRemove && (
          <FontAwesomeIcon
            onClick={onRemove}
            icon={faTrashXmark}
            className="delete-icon"
          />
        )}
      </div>
    </StyledDiv>
  );
};

export default PercentageFieldWithLabel;
